import { comMapping } from '@/components/util/Function/comMapping';

export function getdata() {
    var obj = {
        searchlist: [
             {
                prop: 'companyCode',
                label: '公司代码',
                type: 'input'
            },
            {
                prop: 'companyName',
                label: '公司名称',
                type: 'input'
            },
            {
                prop: 'shuizId',
                label: '税种',
                type: 'select',
                selectval: []
            },
        ],
        searchdata: {
            companyCode: '',
            companyName: '',
            shuizId: '',
            shenbq: ''
        },
        headData: [
            {
                title: '公司代码',
                prop: 'companyCode',
                width: 110
            },
            {
                title: '公司名称',
                prop: 'companyName',
                width: 110
            },
            {
                title: '所属期',
                prop: 'shenbq',
                width: 100
            },
           {
                title: '税表名称',
                prop: 'shuizId',
                width: 130,
                custom: true
            },
            {
                title: "对比时间",
                prop: "createTime",
                width: 100,
                align:"left"
            },
            {
                title: '操作',
                prop: 'cz',
                custom: true,
                fixed: 'right',
                width: 200
            }
        ],
        pagination: {
            pageNum: 1,
            pageSize: 50,
            total: 0,
            paginationkey: 0
        }
    };
    return obj;
}
